
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";

// Pages
import Index from "./pages/Index";
import About from "./pages/About";
import History from "./pages/History";
import Team from "./pages/Team";
import Schedule from "./pages/Schedule";
import Media from "./pages/Media";
import Contact from "./pages/Contact";
import Taekwondo from "./pages/Taekwondo";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import NotFound from "./pages/NotFound";

// Auth Pages
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import PendingApproval from "./pages/Auth/PendingApproval";
import AccountSuspended from "./pages/Auth/AccountSuspended";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";

// Protected Pages
import MembersArea from "./pages/Members/MembersArea";
import AdminArea from "./pages/Admin/AdminArea";

// Auth Components
import PrivateRoute from "./components/auth/PrivateRoute";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <Toaster />
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Index />} />
              <Route path="/about" element={<About />} />
              <Route path="/taekwondo" element={<Taekwondo />} />
              <Route path="/history" element={<History />} />
              <Route path="/team" element={<Team />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/media" element={<Media />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              
              {/* Auth Routes */}
              <Route path="/auth/login" element={<Login />} />
              <Route path="/auth/register" element={<Register />} />
              <Route path="/auth/pending-approval" element={<PendingApproval />} />
              <Route path="/auth/suspended" element={<AccountSuspended />} />
              <Route path="/auth/forgot-password" element={<ForgotPassword />} />
              <Route path="/auth/reset-password" element={<ResetPassword />} />
              
              {/* Protected Routes - Customer Role (Members) */}
              <Route element={<PrivateRoute requireApproval={true} />}>
                <Route path="/members" element={<MembersArea />} />
              </Route>
              
              {/* Protected Routes - Administrator Role */}
              <Route element={<PrivateRoute requiredRole="administrator" requireApproval={true} />}>
                <Route path="/admin" element={<AdminArea />} />
              </Route>
              
              {/* Catch-All Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
